import styled from 'styled-components'
import { bp, font } from 'lib/core/resources/helpers/styled'

export const Wrapper = styled.div`
  border-top: 1px solid ${props => props.theme.palette.general.greyMutted};
  display: flex;
  flex-direction: column;
`

export const ProductBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: center;
  background: ${props => props.theme.palette.general.light};
  padding: 10px 15px;
  border-radius: 10px;
  box-shadow: 1px 1px 4px -1px rgba(82, 82, 82, 1);
  height: 300px;
  margin: 10px;
  ${bp('sm')`
    height: auto;
  `}

  .image {
    margin: 10px auto;
    max-height: 80%;
    width: 45%;

    img {
      max-width: 100%;
      max-height: 100%;
    }
  }

  .remove {
    width: 8px;
    height: 8px;
    margin-left: auto;
    cursor: pointer;

    svg {
      border: 1px solid black;
      width: 10px;
      height: 10px;
      padding: 1px;
    }
  }
`

export const ProductInfo = styled.div`
  margin-bottom: 20px;

  h2 {
    font: ${font('default', 'medium', '20px/1.2')};
  }

  button {
    font-size: 14px;
    margin: auto;
  }
`

export const ProductExtra = styled.div`
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  flex: 1;
  text-align: center;

  .regularPrice {
    padding: 30px;
    font-size: 22px;
    font-weight: bold;
  }

  > div {
    padding: 10px 30px;
  }

  .row {
    border-top: 1px solid ${props => props.theme.palette.general.greyMutted};

    button {
      margin: auto;
    }
  }

  .specs {
    ul {
      list-style: none;
      padding: 0;

      li {
        display: flex;
        justify-content: space-between;
        padding: 5px 0;

        .icon {
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 100%;
          width: 20px;
          height: 20px;

          &--negative {
            background: ${props => props.theme.palette.primary.alphaDark};
          }

          &--positive {
            background: ${props => props.theme.palette.primary.beta};
          }

          svg {
            width: 10px;
            height: 10px;
            fill: ${props => props.theme.palette.general.light};
          }
        }
      }
    }
  }

  .featured {
    margin-top: auto;
  }
`

export const Summary = styled.div`
  text-align: center;

  .react-rater-star {
    width: 12px;
    height: 12px;
    background-size: 12px;
  }

  .rating__average {
    margin-bottom: 10px;

    > div {
      justify-content: center;
    }
  }

  a {
    color: ${props => props.theme.palette.primary.alphaDark};
  }
`
